/* eslint-disable react/no-multi-comp */
import { Skeleton } from '@mui/material'

import { InfoIcon } from '~/components/elements/Icons/generated'
import { Status, type StatusProps } from '~/components/elements/Status/Status'

import { useNoShowText } from './utils/useNoShowText'

interface NoShowAlertTextProps {
  plainText?: boolean
}

const ConditionalStatusWarning = ({
  condition,
  children,
}: StatusProps & { condition: boolean }) =>
  condition ? (
    <Status
      startIcon={<InfoIcon data-testid="no-show-info-icon" />}
      variant="warning"
    >
      {children}
    </Status>
  ) : (
    <>{children}</>
  )

export const NoShowAlertText = ({
  plainText = false,
}: NoShowAlertTextProps) => {
  const noShowAlertText = useNoShowText()

  if (noShowAlertText === null) {
    return <Skeleton sx={{ mb: 1 }} variant="rectangular" width="100%" />
  }

  return (
    <ConditionalStatusWarning condition={!plainText}>
      {noShowAlertText}
    </ConditionalStatusWarning>
  )
}
